import { useLocation, Navigate, Outlet } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const RequireAuth = () => {
  const { auth } = useAuth();
  const location = useLocation();

  // Define allowed paths for program role
  const programAllowedPaths = [
    '/concert',
    '/concertList',
    '/artists',
    '/artists1',
    '/bandList',
    '/otherList',
    '/editOtherType'
  ];

  // Check if current path starts with any of the allowed paths
  const isProgramAllowed = programAllowedPaths.some(path => 
    location.pathname.startsWith(path)
  );

  // Prevent program role from accessing unauthorized pages
  if (auth?.role === 'program' && !isProgramAllowed) {
    return <Navigate to="/concertList" state={{ from: location }} replace />;
  }

  return auth?.accessToken ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export default RequireAuth;
